import { MessageSendStatus, type Message } from '../../types/messages';
import { WebsocketMessageContentType, WebsocketMessageType } from '../../types/ws-events';

export const newMessageTemplate: Omit<Message, 'id' | 'createDate' | 'authorName'> & {
  status: MessageSendStatus;
} = {
  messageType: WebsocketMessageType.In,
  messageContentType: WebsocketMessageContentType.Text,
  message: '',
  messageJson: '',
  status: MessageSendStatus.Sent,
};
